import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  url: '',
  authentication: 'none',
  operation: 'query',
  query: `query {
  # Add your GraphQL query here
  # Example:
  # users {
  #   id
  #   name
  #   email
  # }
}`,
  variables: '{}',
  sendHeaders: false,
  timeout: 30000,
  enableRetry: false,
  maxRetries: 3,
  enablePagination: false,
  cursorPath: 'pageInfo.endCursor',
  hasNextPagePath: 'pageInfo.hasNextPage',
  maxPages: 100,
  cursorVariable: 'after',
  fullResponse: false,
  allowUnauthorizedCerts: false,
};

export default defaults;
